import useQuery from 'shared/hooks/useQuery';
import { Country } from 'shared/types';

const useGetCountries = () => {
  const { data, error, isLoading, isError } = useQuery<Country[]>(
    'countries',
    'v1/countries',
    [],
    { staleTime: Infinity, cacheTime: Infinity }
  );

  return {
    countries: data,
    error,
    isLoading,
    isError,
  };
};

export default useGetCountries;
